import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import React from "react";

export const GameDetailHistoryHeaderBarGameTitleComponent = observer(
    class GameDetailHistoryHeaderBarGameTitleComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        render() {
            return (
                <div>
                    {this.props.gameContext.gameInfo.title}
                </div>
            );
        }
    }
);